export const GET_API_TOKEN = "GET_API_TOKEN"
export const GET_API_TOKEN_SUCCESS = "GET_API_TOKEN_SUCCESS"
export const GET_API_TOKEN_ERROR = "GET_API_TOKEN_ERROR"

export const MODIFY_API_TOKEN = "MODIFY_API_TOKEN"
export const MODIFY_API_TOKEN_SUCCESS = "MODIFY_API_TOKEN_SUCCESS"
export const MODIFY_API_TOKEN_ERROR = "MODIFY_API_TOKEN_ERROR"

export const ADD_API_TOKEN = "ADD_API_TOKEN"
export const ADD_API_TOKEN_SUCCESS = "ADD_API_TOKEN_SUCCESS"
export const ADD_API_TOKEN_ERROR = "ADD_API_TOKEN_ERROR"

export const DELETE_API_TOKEN = "DELETE_API_TOKEN"
export const DELETE_API_TOKEN_SUCCESS = "DELETE_API_TOKEN_SUCCESS"
export const DELETE_API_TOKEN_ERROR = "DELETE_API_TOKEN_ERROR"

export const GET_SYNDI_CLICK_SETTINGS = "GET_SYNDI_CLICK_SETTINGS"
export const GET_SYNDI_CLICK_SETTINGS_SUCCESS = "GET_SYNDI_CLICK_SETTINGS_SUCCESS"
export const GET_SYNDI_CLICK_SETTINGS_ERROR = "GET_SYNDI_CLICK_SETTINGS_ERROR"

export const MODIFY_SYNDI_CLICK_SETTINGS = "MODIFY_SYNDI_CLICK_SETTINGS"
export const MODIFY_SYNDI_CLICK_SETTINGS_SUCCESS = "MODIFY_SYNDI_CLICK_SETTINGS_SUCCESS"
export const MODIFY_SYNDI_CLICK_SETTINGS_ERROR = "MODIFY_SYNDI_CLICK_SETTINGS_ERROR"

export const GET_SYNDI_CLICK_ADMIN_SETTINGS = "GET_SYNDI_CLICK_ADMIN_SETTINGS"
export const GET_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS = "GET_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS"
export const GET_SYNDI_CLICK_ADMIN_SETTINGS_ERROR = "GET_SYNDI_CLICK_ADMIN_SETTINGS_ERROR"

export const MODIFY_SYNDI_CLICK_ADMIN_SETTINGS = "MODIFY_SYNDI_CLICK_ADMIN_SETTINGS"
export const MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS = "MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS"
export const MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_ERROR = "MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_ERROR"

export const GET_SYNDI_CLICK_SOURCE_TYPES = "GET_SYNDI_CLICK_SOURCE_TYPES"
export const GET_SYNDI_CLICK_SOURCE_TYPES_SUCCESS = "GET_SYNDI_CLICK_SOURCE_TYPES_SUCCESS"
export const GET_SYNDI_CLICK_SOURCE_TYPES_ERROR = "GET_SYNDI_CLICK_SOURCE_TYPES_ERROR"

export const CREATE_SYNDI_CLICK_SOURCE_TYPE = "CREATE_SYNDI_CLICK_SOURCE_TYPE"
export const CREATE_SYNDI_CLICK_SOURCE_TYPE_SUCCESS = "CREATE_SYNDI_CLICK_SOURCE_TYPE_SUCCESS"
export const CREATE_SYNDI_CLICK_SOURCE_TYPE_ERROR = "CREATE_SYNDI_CLICK_SOURCE_TYPE_ERROR"